export const appCdnURL = "https://fe-gw.seeronnet.com/nuxt.seer.gw.website/public"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"name":"description","content":"先知命局是一個面向全球的命理文化平台，專注於八字算命與八字排盤服務，讓您了解自己命格的深層意義。專業分析將幫助您預測未來運勢，提供事業、健康、財富等方面的指引，助您順利度過人生每個階段。"},{"name":"keywords","content":"八字算命，八字排盤，名字算命"},{"property":"og:image","content":"https://img-fe.seersecret.com/image/c6b2e9ce8ff62fb5e9cbd47d52966f42-200x200.png"},{"property":"og:image:type","content":"image/x-icon"},{"property":"og:image:width","content":"200"},{"property":"og:image:height","content":"200"}],"link":[{"rel":"icon","type":"image/x-icon","href":"https://fe-gw.seeronnet.com/nuxt.seer.gw.website/public/favicon.ico"},{"rel":"preconnect","href":"https://media.seeronnet.com"},{"rel":"preconnect","href":"https://fe-gw.seeronnet.com"}],"style":[],"script":[{"children":"(function(c,l,a,r,i,t,y){\n\t\t\t\t\t\tc[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n\t\t\t\t\t\tt=l.createElement(r);t.async=1;t.src=\"https://www.clarity.ms/tag/\"+i;\n\t\t\t\t\t\ty=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n\t\t\t\t\t})(window, document, \"clarity\", \"script\", \"uk4kt1glq0\");","type":"text/javascript"}],"noscript":[],"title":"先知命局，陪你找到人生方向"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true